import axios from 'axios';
import banksResponse from './responses/banksResponse.json'
import ratesResponse from './responses/rates_bad.json'
import {makeMoment, md5, formatDateAndTime, getMoscowTime} from '@/helpers/helpers';


const FAKE_DATA = false && process.env.NODE_ENV != "production";

export default {
    data() {
        return {
            connector: {
                // applicationId: 0,
                // serviceClientId: 0,

                state: (update = true) => {
                    let data = {
                        Url: "step",
                        Data: {
                            form: update ? this.$forms.active : null,
                            data: update ? this.getState() : null
                        }
                    };

                    // if ( FAKE_DATA ) {
                    //     //  Пример успешного ответа:
                    //     async function successRequest() {
                    //         return {
                    //             "result": 1,
                    //             "step": 1,
                    //         }
                    //     }

                    //     return successRequest();
                    // }

                    return request('/api/cityads/state', data, true);

                    // localStorage.activeForm = this.$forms.active;
                    // console.log('step', localStorage.activeForm);
                },
                // checkPassportIssuer: () => {
                //     const data = {
                //         divisionCode: this.anketa.divisionCode.value,
                //         issueDate: this.anketa.issueDate.value,
                //     };

                //     return new Promise((resolve, reject) => {
                //         axios
                //             .post(
                //                 'https://cpoint.ru/Services/AutoComplete/api/Main/PassportIssuer',
                //                 data
                //             )
                //             .then((response) => resolve(response.data))
                //             .catch((err) => reject(err));
                //     });
                // },

                SendSmsConsent: () => {
                    const data = {
                        "onlineToken": this.anketa.onlineToken,
                        "mobilePhone": this.anketa.phone.cleanValue()
                    }

                    return request('WidgetSms/SendSmsConsent', data);
                },

                CheckSmsConsent: () => {
                    const data = {
                        "onlineToken": this.anketa.onlineToken,
                        "code": this.anketa.codeSMS.value
                    }

                    return request('WidgetSms/CheckSmsConsent', data);
                },
                
                CreateApplication: () => {
                    const fio = this.$CLObject.fio.split(' '); //this.$anketa.fio.value.split(' ');
                    const data = {
                        "webSiteName": this.CLObject.sitePage,
                        "shopId": this.$CLObject.partnerNumber,
                        "orderId": this.$CLObject.orderId,
                        "client": {
                          "lastName": fio[0] || null,
                          "firstName": fio[1] || null,
                          "middleName": fio.slice(2).join(' ')  || null,
                          "mobilePhone": this.anketa.phone.cleanValue()
                        },
                        "credit": {
                          "term": this.anketa.term.value,
                          "sumGoods": this.anketa.initialPayment.value,
                          "paymentFrequency": 1
                        }
                    };

                    return request('Widget/CreateApplication', data);
                },

                SendJuicyData: () => {
                    const data = {
                        "onlineToken": this.anketa.onlineToken,
                        "iP_IPV4": this.$CLObject.ipAddress,
                        "userAgent": navigator.userAgent,
                        "cookie": this.juicySession
                    };

                    return request('Widget/SendJuicyData', data);
                },

                SendShortApplication: () => {
                    const fio = this.anketa.fio.value.split(' ');
                    let addresses = [this.anketa.registrationAddress.getData()];
                    if (!this.anketa.isAddressesMatches.value) {
                        addresses.push( this.anketa.residentialAddress.getData())
                    }

                    const data = {
                        "onlineToken": this.anketa.onlineToken,
                        "client": {
                            "lastName": fio[0],
                            "firstName": fio[1],
                            "middleName": fio.slice(2).join(' '),
                            "email": this.anketa.email.cleanValue(),
                            "birthDate": this.anketa.birthdate.value,
                            "passport": {
                                "series": this.anketa.passport.cleanValue().substr(0, 4),
                                "number": this.anketa.passport.cleanValue().substr(4),
                                "issueDate": this.anketa.issueDate.value,
                                "divisionCode": this.anketa.divisionCode.value,
                                "issuedBy": this.anketa.issuedBy.value
                                },
                                "gender": this.anketa.gender.value ? 1 : 2, // 1 - М, 2 - Ж
                                //  "monthlyIncome": 50000, // необязательное (инфа Новиков А)
                                "birthPlace": this.anketa.birthplace.value,
                                "IsSameRegAndLiveAddress": this.anketa.isAddressesMatches.value,
                            "Addresses": addresses,
                            "monthlyIncome": this.anketa.income.cleanValue(),
                            // [
                            //     this.anketa.registrationAddress.getData(),
                            //     // this.anketa.residentialAddress.getData()
                            // ]
                        }
                    }
                    // console.log('Widget/SendShortApplication', data);
                    return request('Widget/SendShortApplication', data);
                },

                SendFullApplication: () => {
                    const data = {
                        "onlineToken":  this.anketa.onlineToken,
                        "Client": {
                          "childsCount": "" + this.anketa.childsCount.value,
                          "homePhone": this.anketa.homePhone.cleanValue(), // домашний
                          "inn": this.anketa.inn.value,
                        //   "otherLoanPayments ": 5000,
                        //   "RegDate": "2020-01-01",
                          "Contact": {
                            // "LastName": "Петров",
                            // "FirstName": "Петр",
                            // "MiddleName": "Петрович",
                            "MobilePhone": this.anketa.additionalPhone.cleanValue()
                          },
                    //   "Addresses": [
                    //         {
                    //           "AddressType": 5,
                    //           "IsKladr": true,
                    //           "Region": "Московская",
                    //           "RegionType": "обл",
                    //           "RegionCode": "50",
                    //           "District": null,
                    //           "DistrictType": null,
                    //           "DistrictCode": null,
                    //           "Town": "Химки",
                    //           "TownType": "г",
                    //           "TownCode": "030",
                    //           "Locality": null,
                    //           "LocalityType": null,
                    //           "LocalityCode": null,
                    //           "Street": "Мира",
                    //           "StreetType": "пр-кт",
                    //           "StreetCode": "0036",
                    //           "streetNum": "1",
                    //           "buildingNum": null,
                    //           "blockNum": null,
                    //           "flatNum": null,
                    //           "taxCode": "141401",
                    //           "okato": "456123"
                    //         }
                    //       ],
                          "Work": {
                            // "CompanyName": "ОАО Ромашка",
                            // "IndustryType": this.anketa.industryType.value,
                            "MobilePhone": this.anketa.workPhone.cleanValue(), 
                            "Position": this.anketa.position.value,
                            // "StartDate": "2020-01-01",
                            // "Occupation": 1,
                            // "CompanyType": 1,
                            "EmploymentType": +this.anketa.employmentType.value.id,
                          },
                          "Education": +this.anketa.education.value.id, // 1
                          "MaritalStatus": +this.anketa.maritalStatus.value.id // 1
                        },
                        // "credit": {
                        //     "term": this.anketa.term.value,
                        //     "sumGoods": this.$sumGoods,
                        //     // "paymentFrequency": 1
                        // }
                    }

                    return request('Widget/SendFullApplication', data);
                },
                ApplicationBankInfo: () => {
                    const data = {
                        "onlineToken":  this.anketa.onlineToken //|| "541e12d4-fab2-4e14-b4f5-3deb33e8e688"
                    };

                    return request('Widget/ApplicationBankInfo', data);
                },
                dadata: {
                    fio(q) {
                        return dadata('fio', { q });
                    },
                    address(q) {
                        return dadata('address', { q });
                    },
                    passportIssuer: () => {
                        const data = {
                            divisionCode: this.anketa.divisionCode.value,
                            issueDate: this.anketa.issueDate.getValue()
                        }

                        return dadata('passportIssuer', data)
                    }
                }

            }
        }
    }
}

function request(url, data, isLink = false) {
    const message = {
        Url: url,
        Data: data
    };

    const config = {
        method: 'post',
        url: isLink
            ? url
            :'/api/cityads/push',
        withCredentials: true,
        data: isLink
            ? data
            : message,
    };

    return new Promise((resolve, reject) => {
        axios(config)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

}

// function isLink( str ) {
//     const regExp = /^(http:|https:)/;

//     return regExp.test( str );
// }

function dadata(path, query) {
    const message = {
        Url: path,
        Data: query
    };

    const config = {
        method: 'post',
        url: '/api/cityads/dadata',
        withCredentials: true,
        data: message,
    };

    return new Promise((resolve, reject) => {
        axios(config)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
}

